import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DataUtils } from 'ng-jhipster';

import { Seller } from './seller.model';
import { SellerPopupService } from './seller-popup.service';
import { SellerService } from './seller.service';
import { ModelImage, ModelImageService } from '../model-image';
import { User, UserService } from '../../shared';
import { Device, DeviceService } from '../device';
import { Resource, ResourceService } from '../resource';
import { ApplicationArtatechService } from '../application';
import {ApplicationArtatech} from '../application/application-artatech.model';
@Component( {
    selector: 'dcs-seller-dialog',
    templateUrl: './seller-dialog.component.html'
} )
export class SellerDialogComponent implements OnInit {

    seller: Seller;
    authorities: any[];
    isSaving: boolean;

    shutdowns: ModelImage[];

    users: User[];

    devices: Device[];

    resources: Resource[];

    modelimages: ModelImage[];

    applications: ApplicationArtatech[];
    tutorial: ApplicationArtatech;

    constructor(public activeModal: NgbActiveModal,
                private jhiLanguageService: JhiLanguageService,
                private dataUtils: DataUtils,
                private alertService: AlertService,
                private sellerService: SellerService,
                private modelImageService: ModelImageService,
                private userService: UserService,
                private deviceService: DeviceService,
                private resourceService: ResourceService,
                private applicationService: ApplicationArtatechService,
                private eventManager: EventManager) {
        this.jhiLanguageService.setLocations( [ 'seller' ] );
        this.availableProducts.push(new Product('Blue Shoes', 3, 35));
        this.availableProducts.push(new Product('Good Jacket', 1, 90));
        this.availableProducts.push(new Product('Red Shirt', 5, 12));
        this.availableProducts.push(new Product('Blue Jeans', 4, 60));
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = [ 'ROLE_USER', 'ROLE_ADMIN' ];
        this.modelImageService.query( { filter: 'seller-is-null' } ).subscribe( (res: Response) => {
            if (!this.seller.shutdown || !this.seller.shutdown.id) {
                this.shutdowns = res.json();
            } else {
                this.modelImageService.find( this.seller.shutdown.id ).subscribe( (subRes: ModelImage) => {
                    this.shutdowns = [ subRes ].concat( res.json() );
                }, (subRes: Response) => this.onError( subRes.json() ) );
            }
        }, (res: Response) => this.onError( res.json() ) );
        this.userService.query().subscribe(
            (res: Response) => {
                this.users = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.deviceService.query().subscribe(
            (res: Response) => {
                this.devices = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.resourceService.query().subscribe(
            (res: Response) => {
                this.resources = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.modelImageService.query().subscribe(
            (res: Response) => {
                this.modelimages = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.applicationService.findAll().subscribe(
            (res: Response) => {
                this.applications = res.json();
            }, (res: Response) => this.onError( res.json() ) );
    }

    byteSize(field) {
        return this.dataUtils.byteSize( field );
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile( contentType, field );
    }

    setFileData($event, seller, field, isImage) {
        if ($event.target.files && $event.target.files[ 0 ]) {
            let $file = $event.target.files[ 0 ];
            if (isImage && !/^image\//.test( $file.type )) {
                return;
            }
            this.dataUtils.toBase64( $file, (base64Data) => {
                seller[ field ] = base64Data;
                seller[ `${field}ContentType` ] = $file.type;
            } );
        }
    }

    clear() {
        this.activeModal.dismiss( 'cancel' );
    }

    save() {
        this.isSaving = true;
        if (this.seller.id !== undefined) {
            if (this.seller.tutorialPackage === "")
                this.seller.tutorialPackage = null;
            if (this.seller.tutorialParam === "")
                this.seller.tutorialParam = null;
            this.sellerService.update( this.seller )
                .subscribe( (res: Seller) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        } else {
            this.sellerService.create( this.seller )
                .subscribe( (res: Seller) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
        }
    }

    onSelectTutorial(event) {
        this.seller.tutorialPackage = this.tutorial.packageName;
    }

    private onSaveSuccess(result: Seller) {
        this.eventManager.broadcast( { name: 'sellerListModification', content: 'OK' } );
        this.isSaving = false;
        this.activeModal.dismiss( result );
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError( error );
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }

    trackModelImageById(index: number, item: ModelImage) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }

    trackDeviceById(index: number, item: Device) {
        return item.id;
    }

    trackResourceById(index: number, item: Resource) {
        return item.id;
    }

    trackApplicationById(index: number, item: ApplicationArtatech) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[ i ].id) {
                    return selectedVals[ i ];
                }
            }
        }
        return option;
    }





    availableProducts: Array<Product> = [];
    shoppingBasket: Array<Product> = [];

    orderedProduct($event: any) {
        let orderedProduct: Product = $event.dragData;
        orderedProduct.quantity--;
    }

    addToBasket($event: any) {
        let newProduct: Product = $event.dragData;
        for (let indx in this.shoppingBasket) {
            let product: Product = this.shoppingBasket[indx];
            if (product.name === newProduct.name) {
                product.quantity++;
                return;
            }
        }
        this.shoppingBasket.push(new Product(newProduct.name, 1, newProduct.cost));
        this.shoppingBasket.sort((a: Product, b: Product) => {
            return a.name.localeCompare(b.name);
        });
    }

    totalCost(): number {
        let cost: number = 0;
        for (let indx in this.shoppingBasket) {
            let product: Product = this.shoppingBasket[indx];
            cost += (product.cost * product.quantity);
        }
        return cost;
    }


}

@Component( {
    selector: 'dcs-seller-popup',
    template: ''
} )
export class SellerPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(private route: ActivatedRoute,
                private sellerPopupService: SellerPopupService) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe( params => {
            if (params[ 'id' ]) {
                this.modalRef = this.sellerPopupService
                    .open( SellerDialogComponent, params[ 'id' ] );
            } else {
                this.modalRef = this.sellerPopupService
                    .open( SellerDialogComponent );
            }

        } );
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}

class Product {
    constructor(public name: string, public quantity: number, public cost: number) {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller-dialog.component.ts